import React from 'react'
import PropTypes from 'prop-types'
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from './ReactEcharts';

var replaceReg = /([&<>"'])/g;
var replaceMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;'
};

function encodeHTML(source) {
  return source == null
  ? ''
  : (source + '').replace(replaceReg, function (str, c) {
    return replaceMap[c];
  });
}

class HeatMapChart extends React.Component {
  constructor(props) {
    super(props)
    this.itemStyle = {
      normal: {
      },
      emphasis: {
        barBorderWidth: 1,
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: 'rgba(0,0,0,0.5)'
      }
    };

    this.state = this.getInitialState();
  }
  getInitialState = () => ({option: this.getOption()});

  componentWillReceiveProps(nextProps) {
    if (nextProps.data === this.props.data)
      return;
    this.updateChart(nextProps)
  }

  getOption = () => ({
    color: ['#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9',
      '#bc80bd', '#ccebc5', '#8dd3c7', '#ffffbc', '#bebada', '#ffed6f'],
    tooltip : {
      position: 'top',
      formatter: d => {
        return `${d.value[2]}<br><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${encodeHTML(d.color)};"></span>${d.value[3]}`;
      }
    },
    xAxis: {
      type: 'category',
      show: false,
    },
    yAxis: {
      type: 'category',
      show: false,
    },
    grid: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    visualMap: {
      min: 0,
      max: 10,
      calculable: true,
      realtime: false,
      orient: 'horizontal',
      inRange: {
        color: ['#b3de69', '#80b1d3', '#fdb462', '#fb8072'],
      },
      show: false,
    },
    series: []
  });

  updateChart = (props) => {
    let {data} = props;
    const option = cloneDeep(this.state.option); // immutable

    let yCount = Math.round(Math.sqrt(data.length / 8)) + 1;
    let xCount = Math.ceil(data.length / yCount);
    option.xAxis.data = new Array(xCount).fill('').map((a, index) => index);
    option.yAxis.data = new Array(yCount).fill('').map((a, index) => index);
    option.series = [{
      type: 'heatmap',
      itemStyle: this.itemStyle,
      encode: {x:0,y:1,name:2,value:3},
      data: data.map((d, index) => [Math.floor(index / yCount), index % yCount, d.name,
        d.value || '-'])
    }];

    this.setState({
      option,
    });
  };

  onChartClick(params) {
    if(params.componentType !== 'series')
      return;
    if(this.props.onSelected)
      this.props.onSelected(params.dataIndex)
  }

  render() {
    let onEvents = {
      'click': this.onChartClick.bind(this),
    }
    return (
      <ReactEcharts ref='echarts_react'
        option={this.state.option}
        style={{width: this.props.width, height: this.props.height}}
        onEvents={onEvents}
      />
    )
  }
}
 
HeatMapChart.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      value: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  onSelected: PropTypes.func,
}

export default HeatMapChart
